import {
  Empty,
  GetWorkAreaTreeParams,
  useGetWorkAreaTreeSuspense,
} from "@/orval/gen"
import {
  TreePillsInput,
  TreePillsInputProps,
} from "@components/tree/tree-pills-input"
import { useTranslation } from "react-i18next"

interface DepartmentWorkareaTreeSelectProps extends Omit<
  TreePillsInputProps<Empty>,
  "tree" | "value" | "onChange"
> {
  value?: string[] | undefined
  onChange?: (value: string[]) => void
  params?: GetWorkAreaTreeParams
}

export function DepartmentWorkareaTreeSelect({
  value,
  onChange,
  params,
  ...props
}: DepartmentWorkareaTreeSelectProps) {
  const { data: workAreaTree } = useGetWorkAreaTreeSuspense(params)
  const { t } = useTranslation("app_server")
  return (
    <TreePillsInput
      label={t("Departments")}
      tree={workAreaTree.tree}
      initialCheckedState={value}
      onCheckedStateChange={onChange}
      initialExpandedState={workAreaTree.initialExpandedState}
      {...props}
    />
  )
}
